import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActivityTabs, buttonTypes } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { BookingActivity, ClassType, SessionBookingDTO } from 'src/app/shared/Models/SessionBookingDTO';
import { DayOfWeek } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { ActivitiesService } from '../../activities.service';

@Component({
  selector: 'app-activity-slot-summary',
  templateUrl: './activity-slot-summary.component.html',
  styleUrls: ['./activity-slot-summary.component.scss']
})
export class ActivitySlotSummaryComponent implements OnInit, OnDestroy {
  editButton: ButtonValue;
  selectedBookingSlotObj: SessionBookingDTO;
  activityName: string;
  Locations: string;
  Instructors: string;
  ratePlan: any;
  OperationCurrency: any;
  RestaurantSettingsData: any;
  isSessionClass: boolean;
  showAllSlots: boolean;
  showRatePalns: boolean;
  Subscriptions: Subscription = new Subscription;
  SelectedDates = [];
  allAvailableDates = [];
  dayOfWeek = DayOfWeek;
  SelectedTimeSlots = [];
  OpenbookingSlots = [];
  selectedClassSchedule: any = [];
  SummaryData: any;
  ClassType = ClassType;
  constructor(public ts: TranslateService, public activityService: GuestService) {
    this.Subscriptions.add(
      this.activityService.restaurantWidgetSettings$.subscribe(data => {
        this.RestaurantSettingsData = data;
        this.OperationCurrency = this.RestaurantSettingsData.OperationCurrency;
      }));
    this.Subscriptions.add(
      this.activityService.TabChange$.subscribe(data => {
        if (data === ActivityTabs.ReservationDetails) {
          if (this.activityService.bookingSection$.value === BookingActivity.ClassBooking) {
            if (this.activityService.SessionBookingObj) {
              this.SummaryData = this.activityService.SessionBookingObj;
              this.ratePlan = {};
              this.isSessionClass = this.activityService.SessionBookingObj.ClassType === ClassType.Session;
              if (this.isSessionClass) {
                this.SelectedTimeSlots = this.activityService.SaveBookingObj.SelectedTimeSlots;
              } else {
                this.ratePlan['selectedClassSchedule'] = this.activityService.SaveBookingObj.selectedClassSchedule
              }
            }
            this.setSummaryData();
            this.getInstructors();
            this.getLocations();
            this.OpenbookingSlots = [];
          } else {
            this.isSessionClass = false;
            this.SelectedTimeSlots = [];
            this.selectedClassSchedule = [];
            if (this.activityService.bookingSection$.value === BookingActivity.PrivateLesson) {
              this.selectedBookingSlotObj = this.SummaryData = this.activityService.SessionBookingObj;
              this.activityName = this.activityService.SelectedActivity$.value?.LessonName;
              this.activityService.SaveBookingObj.ActivityName = this.activityName;
              this.getInstructors();
              this.getLocations();
            } else {
              this.SummaryData = this.activityService.openBookingData;
              this.Locations = this.activityService.openBookingData.LocationName
              this.activityService.SaveBookingObj.ActivityName = 'Open Booking';
              this.activityService.SaveBookingObj.TableNames = this.Locations = this.activityService.openBookingData.LocationName;
            }
            this.OpenbookingSlots = this.activityService.SaveBookingObj.OpenTimeSlots;
            this.OpenbookingSlots.sort((a, b) => Utilities.parseDateString(a.LocalTime).getTime() - Utilities.parseDateString(b.LocalTime).getTime());
            
          }
        }
        if(this.SummaryData && this.SummaryData.Slots && this.SummaryData.Slots.length>0)
        {
          this.SummaryData.Slots.sort((a, b) => Utilities.parseDateString(a.LocalTime).getTime() - Utilities.parseDateString(b.LocalTime).getTime());
        }
      }));
    this.Subscriptions.add(
      this.activityService.SelectedClassSchedule$.subscribe(data => {
        if (data) {
          this.selectedClassSchedule = data
        }
      }));
    this.Subscriptions.add(
      this.activityService.RatePlanList$.subscribe(data => {
        this.ratePlan = data;
        if (this.ratePlan && !this.ratePlan?.SlotList) {
          this.ratePlan.SlotList = [];
        }
        if(this.ratePlan && this.ratePlan != null) {
        (this.ratePlan && this.ratePlan.SlotList.length>0) ??  this.ratePlan.SlotList.sort((a, b) => Utilities.parseDateString(a.TimeRange.Start).getTime() - Utilities.parseDateString(b.TimeRange.Start).getTime());           
      }
      }));

    this.Subscriptions.add(this.activityService.isSplitPayment$.subscribe(data => {
      this.editButton.disbaledproperity = data;
    }));
  }

  getTimeRange(data) {
    const SessionData = [];
    this.ratePlan.RatePlanCalculations.forEach(element => {
      if (element.TimeRange.Start.split('T')[0] === data.StartDate) {
        SessionData.push(element);
      }
    });
    return SessionData;
  }

  ngOnInit(): void {
    this.editButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('edit'),
      customclass: 'reservation-confirmation__cancel-reservation',
      disbaledproperity: this.activityService.isEditEnable
    };

  }


  setSummaryData() {
    const SelectedActivity = this.activityService.SelectedActivity$.value;
    this.selectedBookingSlotObj = this.activityService.SessionBookingObj;
    if (this.selectedBookingSlotObj.ClassType) {

    }
    this.activityName = SelectedActivity?.LessonName;
    this.activityService.SaveBookingObj.ActivityName = this.activityName;
    this.isSessionClass = SelectedActivity?.ClassType === ClassType.Session;
  }
  getLocations() {
    let SelectedLocList = '';
    this.SummaryData?.Location.forEach((loc, index) => {
      const selectedLoc = this.activityService.LocationList.filter(data => data.Id === loc)[0];
      if (selectedLoc) {
        SelectedLocList = SelectedLocList + (selectedLoc.Name);
      }
      if (index !== this.selectedBookingSlotObj.Location?.length - 1) {
        SelectedLocList = SelectedLocList + ', ';
      }
    });
    this.Locations = SelectedLocList;
    this.activityService.SaveBookingObj.TableNames = this.Locations;
  }

  getInstructors() {
    let SelectedStaffList = '';
    this.SummaryData?.StaffId.forEach((staff, index) => {
      const selectedStaff = this.activityService.InstructorList.filter(data => data.Id === staff)[0];
      if (selectedStaff) {
        SelectedStaffList = SelectedStaffList + (selectedStaff.Name + ' ' + (selectedStaff.LastName || ''));
      }
      if (index !== this.selectedBookingSlotObj.StaffId?.length - 1) {
        SelectedStaffList = SelectedStaffList + ', ';
      }
    });
    this.Instructors = SelectedStaffList;
    this.activityService.SaveBookingObj.Staffs = this.Instructors;
  }

  gotoPreviousPage(event) {
    this.activityService.offTimer();
    if (this.activityService.bookingSection$.value === BookingActivity.ClassBooking) {
      this.activityService.TabChange$.next(ActivityTabs.ActivitySelection);
    } else if (this.activityService.bookingSection$.value === BookingActivity.PrivateLesson) {
      this.activityService.TabChange$.next(ActivityTabs.PrivateLesson);
    } else {
      this.activityService.TabChange$.next(ActivityTabs.BookingSelection);
    }
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}
